module.exports = {
  newsroomHeaderMenuItemHeight: 55,
  indicatorHeight: 50,
  heavyBorderBlack: '3px solid var(--black)',
  heavyBorderTeal: '3px solid var(--teal)',
  heavyBorderBlue: '3px solid var(--blue)',
};
